import {dbg, decycle, find, findAll, getDeviceType} from "../../../functions"

let _cPM = false,
    _user = undefined,
    _btn = undefined
export default class ValidateStep {
    constructor(cPM, user, btn) {
        _cPM = cPM
        _user = user
        _btn = btn
        this.errorClass = "powermail_field_error"
        this.valid = false
        this.continueButton = btn
        // console.log("ValidateStep constructed with following objects ", this);
    }

    /* HELPER FUNCS */
    /**
     * only allows numbers in given input field
     * @param {HTMLElement} input
     */
    onlyNumbers(input) {
        if (!input) {
            console.warn("onlyNumbers: no input element found")
            return
        }
        input.oninput = function () {
            this.value = this.value.replace(/[^0-9]/g, "")
        }
    }

    /**
     * clears the error class from the given element
     * @param {HTMLElement} elem
     */
    clearError(elem) {
        // console.debug("clearError: ", elem);
        if (elem && elem.length >= 1) {
            // if the element is a NodeList, loop through all elements
            for (let i = 0; i < elem.length; i++) {
                if (elem[i].classList.contains(this.errorClass)) {
                    elem[i].classList.remove(this.errorClass)
                }
            }
        } else {
            if (elem && elem.classList.contains(this.errorClass)) {
                elem.classList.remove(this.errorClass)
            }
        }
    }

    /**
     * adds the error class to the given element
     * @param {HTMLElement} elem
     */
    addError(elem) {
        // console.debug("addError: ", elem);
        if (elem && elem.classList) {
            if (!elem.classList.contains(this.errorClass)) {
                elem.classList.add(this.errorClass)
                this.valid = false
                // console.log("addError: added error class to element", elem);
            }
        } else {
            // console.warn("addError: no element found", elem);
        }
    }

    /**
     * checks if the given element has a value
     * @param {HTMLElement} elem - input field
     * @returns {boolean} true if the element is valid, false if not
     */
    checkIfValue(elem) {
        if (elem.value === "") {
            this.addError(elem)
            // this.disableContinueButton();
            return false
        } else {
            this.clearError(elem)
            // this.enableContinueButton();
            return true
        }
    }

    /**
     * checks and validates if the given element is checked
     * @param {HTMLElement} elem - checkbox or radio button
     * @returns {boolean} true if the element is checked, false if not
     */
    checkIfChecked(elem) {
        try {
            if (elem.checked) {
                this.clearError(elem)
                // this.enableContinueButton();
                return true
            } else {
                this.addError(elem)
                // this.disableContinueButton();
                return false
            }
        } catch (error) {
            console.error("checkIfChecked: error while checking if element is checked", error)
            return true
        }
    }

    /**
     * disables the continue button
     * @returns {void}
     */
    disableContinueButton() {
        let btn = this.continueButton
        if (btn) {
            btn.setAttribute("disabled", "disabled")
        } else {
            console.warn("disableContinueButton: no button found")
        }
    }

    /**
     * enables the continue button
     * @returns {void}
     */
    enableContinueButton() {
        let btn = this.continueButton
        if (btn) {
            // console.log("enableContinueButton: enabling continue button");
            btn.removeAttribute("disabled")
        } else {
            console.warn("enableContinueButton: no button found")
        }
    }

    hideError() {
        let error = this.errorField
        if (error) {
            error.classList.remove("vis")
        }
    }

    showError() {
        let error = this.errorField
        if (error) {
            error.classList.add("vis")
        }
    }
}
